import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>(
    'button',
    'styledComponent',
    'autocomplete'
)`
    ${propStyles};
`;
StyledComponent.defaultProps = {
    display: 'flex',
    flex: '0 0 auto',
    position: 'relative',
    zIndex: 'dropdown',
    cursor: 'pointer',
    outline: 'none',
    borderStyle: 'none',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/ClearButton.tsx